export const PROJECT_INFO = 'PROJECT_INFO';